import * as logger from 'loglevel'

const level = process.env.LOG_LEVEL

logger.setLevel((level === 'off' ? 'silent' : (level as logger.LogLevelDesc)) ?? logger.levels.DEBUG)

export default logger
